import React from 'react';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

import { pageNames } from '@atc/bonnet-paths';
import { useFeatures } from '@atc/features';

import { PageSection } from 'reaxl';

import vdpAdsDuck from '@/ducks/vdp/vdpAdsDuck.js';

import AtcAdSlot from '@/containers/AtcAdSlot';
import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

import LazyComponent from '@/components/LazyComponent';

const { VEHICLE_DETAILS } = pageNames;

function ShowcaseAdSlotContainer({
    className,
    wrap = false,
}) {
    const { ads: [, { mrecAdSlot } = {}] } = useFeatures(['ads']);

    const adSize = [[300, 250]];
    const adSlotId = mrecAdSlot?.adSlotId;
    const adPos = mrecAdSlot?.adPos;
    const width = _get(adSize, '[0][0]', 0);
    const height = _get(adSize, '[0][1]', 0);

    const adSlot = (
        <LazyComponent
            key="showcase_lazy"
            width={width}
            height={height}
        >
            <AtcAdSlot
                className={className}
                slotId={adSlotId}
                lazyLoading
                size={adSize}
                adSelector={vdpAdsDuck.selectors.getDuckState}
                pageName={VEHICLE_DETAILS}
                targeting={{
                    pos: adPos,
                    prd: 'rc12',
                }}
                lazyLoadingBottomOffset={-100}
                lazyLoadingTopOffset={-100}
                showPlaceholder
                preserveSpace
            />
        </LazyComponent>
    );

    const wrapAdSlot = () => (
        <PageSection
            className="col-lg-8"
            uiContext="section-2"
            alignment="left"
        >
            {adSlot}
        </PageSection>
    );
    return (
        <DisableAdsFeatureFlag>
            {wrap ? wrapAdSlot() : adSlot}
        </DisableAdsFeatureFlag>
    );
}

export default React.memo(ShowcaseAdSlotContainer, _isEqual);
